import { createMiddleware } from '@tanstack/react-start';

/**
 * Lazy variant of the auto-generated `attachSupabaseAuth` middleware.
 *
 * The generated version statically imports `@/integrations/supabase/client`,
 * which pulls @supabase/auth-js + realtime + storage into the homepage's
 * main entry chunk (~137 KiB unused on /). This version defers that import
 * until an actual server-fn RPC is dispatched, so the Supabase client only
 * lands in a chunk that's loaded on demand (forms, admin, lead magnets).
 *
 * Behavior is otherwise identical: read the current session and attach
 * `Authorization: Bearer <access_token>` to outgoing server-fn requests.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    const { supabase } = await import('@/integrations/supabase/client');
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
